module.exports = __webpack_public_path__ + "static/media/Noirden-Regular.e5e5276e.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Noirden-Regular.otf
// module id = 3360
// module chunks = 68